export { default as ReceivingManualListTemplate } from './manual/ReceivingManualListTemplate';
export { default as ReceivingAutomatedListTemplate } from './automated/ReceivingAutomatedListTemplate';
export { default as ReceivingEditTemplate } from './ReceivingEditTemplate';
export { default as ReceivingDetailTemplate } from './ReceivingDetailTemplate';
export { default as ReceivingHistoryLogList } from './ReceivingHistoryLogList';
export { default as ReceivingHistoryLogListTemplate } from './ReceivingHistoryLogListTemplate';
export { default as ReceivingExpandListTemplate } from './ReceivingExpandListTemplate';



// WEBPACK FOOTER //
// ./src/themes/default/modules/receiving/pages/index.js